export default {
  options: {
    true: 'Da',
    false: 'Nu',
  },
};
